import AbstractCommand from '../AbstractCommand';
import companyCustomerCreate from '../../requests/customers/companyCustomerCreate';

/**
 *
 */
export default class CreateCompanyCustomerCommand extends AbstractCommand {
	/**
	 *
	 * @param company
	 * @param companyCustomer
	 */
	constructor(company, companyCustomer) {
		super();
		this.company = company;
		this.companyCustomer = companyCustomer;
	}

	/**
	 *
	 * @param successCallback
	 * @param failCallback
	 */
	execute(successCallback, failCallback) {
		companyCustomerCreate(this.company.id, this.companyCustomer)
			.then((response) => {
				successCallback(response);
			})
			.catch((err) => {
				if (failCallback) {
					failCallback(err);
				}
			});
	}
}
